import React from "react";
import { Link } from "gatsby";
import {
  Check,
} from "./Icons";

export default function WorksWith({ to, toolkitItem, url }) {
  return (
    <li className="flex items-center">
      <Check className="inline-block mr-2 basis-[36px]" />
      <span>
        <Link href={url}>{toolkitItem}:</Link> &nbsp;{to}
      </span>
    </li>
  );
}
